<template>
    <v-dialog v-model="dialogDeletePart" max-width="400" :lazy="true" persistent>
        <v-card>
            <v-card-title class="headline">{{ $t('part-deletion') }}</v-card-title>

            <v-card-text>
                <p class="text-xs-left">
                    {{ $t('part-delete-text1') }}
                </p>
                <p class="text-xs-left">
                    {{ $t('part-delete-text2') }}
                </p>
            </v-card-text>
            
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn flat @click.native="close()">{{ $t('no') }}</v-btn>
                <v-btn color="success" flat @click.native="valid()">{{ $t('yes') }}</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>

<script>
import { mapActions } from 'vuex';
import store from '@/stores';
import * as types from '@/stores/types';

export default {
    name:  'delete-part-dialog',
    store: store,
    data:  function()
    {
        return {
            partIndex:        -1,
            dialogDeletePart: false,
        };
    },
    methods: {
        ...mapActions({
            deletePartAction: types.A_SONG_DELETE_PART,
        }),
        /**
         * Ouverture de la boîte de dialogue
         *
         * @author Fabien Bellanger
         * @param {Number} partIndex Indice de la partie
         */
        open: function(partIndex)
        {
            this.dialogDeletePart = true;
            this.partIndex = partIndex;
        },
        /**
         * Fermeture de la boîte de dialogue
         *
         * @author Fabien Bellanger
         */
        close: function()
        {
            this.dialogDeletePart = false;
        },
        /**
         * Valider la suppression
         *
         * @author Fabien Bellanger
         */
        valid: function()
        {
            this.deletePartAction(this.partIndex);

            this.close();
        },
    },
};
</script>
